import PlainInput from "../src/plain/PlainInput.js";
export default class ElixInput extends PlainInput {}
customElements.define("elix-input", ElixInput);
